export default {
	getIsLoadIng:function (state) {
		if(state.data) {
			return true;
		}
		return false
	},
	getData: function(state) {
		console.log("取数据");
		if(state.data) {
			return state.data;
		}
		return undefined
	},
	artistInfo:function(state){
		if(state.data){
			if(state.data.artistInfo && typeof (state.data.artistInfo)=='object'){
				return state.data.artistInfo;
			}
		}
		return '';
	},
	artMket:function(state){
		if(state.data){
			if(state.data.market && typeof (state.data.market)=='object'){
				return state.data.market;
			}
		}
		return '';
	},
	artPechart:function(state){
		if(state.data){
			if(state.data.auctionIndexValue && typeof (state.data.auctionIndexValue)=='object'){
				return state.data.auctionIndexValue;
			}
		}
		return '';
	},
	artYechart:function(state){
		if(state.data){
			if(state.data.comprehensiveIndexValue && typeof (state.data.comprehensiveIndexValue)=='object'){
				return state.data.comprehensiveIndexValue;
			}
		}
		return '';
	},
	Auctions:function(state){
		if(state.data){
			if(state.data.Auctions && typeof (state.data.Auctions)=='object'){
				return state.data.Auctions;
			}
		}
		return '';
	},
	sealData:function(state){
		if(state.data){
			if(state.data.sealData && typeof (state.data.sealData)=='object'){
				return state.data.sealData;
			}
		}
		return '';
	}
}
